import { Button, Input, Modal } from "@mui/joy";
import React, { Dispatch, SetStateAction, useState } from "react";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../../../../appConstants";
import CrossIcon from "../../../../../svg/Ads_Dashboard_Developement2/CrossIcon/elements.svg";
import appError from "../../../../../appError";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
type Condition = {
  metric: string;
  parameter: string;
  Operation: string;
  initial_value: string;
  dependent_value: string;
};
type ListProps = {
  condition_name: string;
  condition_array: Condition[];
  condition_id: string;
  dashboard: string;
};
type CreateNewConditionModalProps = {
  setConfirmConditionToggle: Dispatch<SetStateAction<boolean>>;
  localConditionsArr: Condition[];
  newConditionsArr: Condition[];
  setCreateNewCond: Dispatch<SetStateAction<boolean>>;
  ClearAll: () => void;
  fetchConditionsData: () => void;
  listarr: ListProps[];
  page_name: string;
};
const CreateNewConditionModal: React.FC<CreateNewConditionModalProps> = ({
  setConfirmConditionToggle,
  localConditionsArr,
  newConditionsArr,
  setCreateNewCond,
  ClearAll,
  fetchConditionsData,
  listarr,
  page_name
}) => {
  const [newCondtionListName, setNewConditionListName] = useState<string>("");
  const { brand_id, platform_id } = useSelector((state: any) => state.appData);
  const [temp_list_name_error, setTemp_list_name_error] =
    useState<boolean>(false);
  const [saveNewListToggle, setSaveNewListToggle] = useState<boolean>(false);
  const createNewCondition = async (new_arr: Condition[]) => {
    const token = localStorage.getItem("token");
    const cleaned_arr = new_arr.map(obj => 
      Object.fromEntries(
        Object.entries(obj).filter(([key]) => !key.endsWith('_error'))
      )
    );
    try {
      setSaveNewListToggle(true);
      const temp_obj = {
        dashboard: page_name,
        condition_name: newCondtionListName,
        condition_array: cleaned_arr,
      };
      const res = await axios.post(
        `${BASE_URL}settings/dashboardSettings/conditions?brand_id=${brand_id}&platform_id=${platform_id}`,
        temp_obj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(res?.data?.data?.message);
      fetchConditionsData();
      ClearAll();
      setCreateNewCond(false);
    } catch (error) {
      appError(error);
    } finally {
      setSaveNewListToggle(false);
    }
  };

  const createNewListHandler = () => {
    if (newCondtionListName === "") {
      setTemp_list_name_error(true);
      return;
    }
    else {
      if(listarr?.find(item => item?.condition_name ===  newCondtionListName)){
        appError("Please enter Unique Condition List Name");
      }
      else {
        let tempNewConditions = newConditionsArr.filter(
          (cond: Condition) =>
            cond?.metric !== "" &&
            cond?.parameter !== "" &&
            cond?.Operation !== "" &&
            cond?.initial_value !== ""
        );
        let new_arr = [...localConditionsArr, ...tempNewConditions];
        createNewCondition(new_arr);
        }
      }
  };
  return (
    <Modal
      open={true}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <div className="relative">
        <div
          style={{
            height: 352,
            width: 600,
            backgroundColor: WHITE.W_100,
            borderRadius: 16,
            padding: 40,
            display: "flex",
            flexDirection: 'column',
            justifyContent: "space-between",
            gap: "40px"
          }}
        >
          <div className="flex flex-col items-start gap-1 self-stretch">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              Add New Condition
            </div>
            <div
              style={{
                color: "var(--Text-Primary-Grey, #97979A)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "22px",
              }}
            >
              Assign a name to the new condition to make it easy to recognize in
              the future
            </div>
          </div>

          <div className="flex flex-col items-start gap-2 self-stretch">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Custom Condition Name
            </div>
            <Input
              placeholder="Name your custom conditions"
              sx={{
                "--Input-focusedThickness": "0px",
                width: "100%",
                height: "44px",
                paddingY: "8px",
                paddingX: "16px",
                fontSize: "12px",
                fontWeight: "500",
                lineHeight: "18px",
                backgroundColor: "#FFF",
                "&.Mui-disabled": {
                  backgroundColor: "#F3F3F7",
                },
                borderRadius: "8px",
                border: "1px solid #EAEAED",
              }}
              name="local_Cond_name"
              value={newCondtionListName}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setNewConditionListName(e.target.value)
              }
            />
            {temp_list_name_error && (
              <div className="flex items-center gap-1 self-stretch">
                <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <circle
                      cx="7.99967"
                      cy="7.99967"
                      r="6.66667"
                      stroke="#D10C00"
                      stroke-width="1.5"
                    />
                    <path
                      d="M7.99401 10H8"
                      stroke="#D10C00"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 8L8 5.33333"
                      stroke="#D10C00"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  style={{
                    color: "var(--Text-Event-Red, #D10C00)",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "18px",
                  }}
                >
                  Condition name already exists
                </div>
              </div>
            )}
          </div>

          <div className="flex gap-4 justify-between">
            <Button
              // loading={lodingOnSave}
              sx={{
                height: 54,
                width: "50%",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
                backgroundColor: "#FFF",
                lineHeight: "18px",
                color: "black",
                borderRadius: 8,
                paddingY: "6px",
                border: "1px solid #EAEAED",
                ":hover": {
                  backgroundColor: "#FFF",
                },
              }}
              onClick={() => {
                setCreateNewCond(false);
                setConfirmConditionToggle(true);
              }}
            >
              Back
            </Button>
            <Button
              disabled={saveNewListToggle}
              sx={{
                height: 52,
                width: "50%",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
                backgroundColor: "#1565C0",
                lineHeight: "18px",
                color: "#FFF",
                borderRadius: 8,
                paddingY: "6px",
              }}
              onClick={createNewListHandler}
            >
              Save
            </Button>
          </div>
        </div>
        <div
          className="absolute top-4 right-4 flex p-1 "
          style={{
            zIndex: 100,
            backgroundColor: "#F2F2F5",
            borderRadius: "20px"
          }}
        >
          <img
            src={CrossIcon}
            alt="OverView Icon"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setCreateNewCond(false);
              setConfirmConditionToggle(false);
              ClearAll();
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CreateNewConditionModal;
